export type OfflineMutationType =
  | "CREATE_CHECK_IN"
  | "START_EXPERIMENT"
  | "COMPLETE_EXPERIMENT"
  | "CREATE_REFLECTION";

export type OfflineMutation = {
  id: string;
  type: OfflineMutationType;
  payload: unknown;
  createdAt: string;
  retryCount: number;
};

const QUEUE_KEY = "andrum-offline-queue";

export function loadQueue(): OfflineMutation[] {
  try {
    const raw = localStorage.getItem(QUEUE_KEY);
    if (!raw) return [];
    return JSON.parse(raw) as OfflineMutation[];
  } catch {
    return [];
  }
}

export function saveQueue(queue: OfflineMutation[]): void {
  try {
    localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
  } catch {
    // ignore quota errors
  }
}

export function enqueue(mutation: Omit<OfflineMutation, "id" | "createdAt" | "retryCount">): void {
  const queue = loadQueue();
  queue.push({
    ...mutation,
    id: crypto.randomUUID(),
    createdAt: new Date().toISOString(),
    retryCount: 0,
  });
  saveQueue(queue);
}

export function clearSynced(ids: string[]): void {
  const queue = loadQueue().filter((m) => !ids.includes(m.id));
  saveQueue(queue);
}
